<template>
  <div id="app"  v-cloak>
    <Loader min-time="500" />
    <router-view />
  </div>
</template>

<script>
import Loader from "./components/Loader.vue";
export default {
  name: "App",
  components: {
    Loader
  }
};
</script>

<style lang="scss">
@font-face {
    font-family: 'Plumcake';
    src: url('../fonts/Plumcake-Light.woff2') format('woff2'),
        url('../fonts/Plumcake-Light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Plumcake';
    src: url('../fonts/Plumcake-Regular.woff2') format('woff2'),
        url('../fonts/Plumcake-Regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}



@import url("https://fonts.googleapis.com/css2?family=Raleway:wght@400;600&display=swap");

html,
body {
  margin: 0;
  padding: 0;
  min-height: 100%;
}

body {
  background: linear-gradient(
    0deg,
    $bg-gradient-bottom 0%,
    $bg-gradient-top 100%
  );
  font-family: "Plumcake", "Times New Roman", Times, serif;
}

.container {
  max-width: $max-width;
  margin: 0 auto;
  padding: 0 1rem;
}

.button {
  transition: all 0.1s ease-out;
  &:hover {
    transform: translateY(-2px) rotate(-2deg);
  }
  &:active {
    transform: translateY(0) rotate(-2deg);
  }
}

h1,
h2,
h3 {
  color: $blue;
  text-transform: uppercase;
}

h1 {
  // font-size: 4.5rem;
  // line-height: 4.5rem;
  // margin: 1rem 0 1rem 0;
  font-size: 3rem;
  margin: 0 0 1rem 0;
  line-height: 3rem;
}

h2 {
  font-size: 3rem;
  text-align: center;
  margin: $margin 0 2rem 0;
  text-align: center;
}

h3 {
  font-size: 2.3rem;
  margin: 0;
}

p {
  font-family: "Raleway", helvetica, Arial, sans-serif;
  font-size: 1.15rem;
  margin: 0;
  line-height: 1.8rem;
  color: $blue;
  margin-bottom: 1rem;

}

[v-cloak] {
  display: none;
}
</style>
